import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createActionGroup, createFeature, createReducer, createSelector, on, props } from '@ngrx/store';
import { PersonInterface } from '../../+models';

// The member overview/detail uses a ComponentStore; this small feature only
// holds the members whose name a breadcrumb needs to select by id.
export const NAME = 'members';

export type State = EntityState<PersonInterface>;

export const adapter: EntityAdapter<PersonInterface> = createEntityAdapter<PersonInterface>();

export const initialState: State = adapter.getInitialState();

export const actions = createActionGroup({
  source: 'Members',
  events: {
    'Upsert Members': props<{ members: PersonInterface[] }>(),
  },
});

export const feature = createFeature({
  name: NAME,
  reducer: createReducer(
    initialState,
    on(actions.upsertMembers, (state, { members }): State => adapter.upsertMany(members, state))
  ),
});

/**
 * Null-safe display name (matching the member detail header) for a member
 * breadcrumb. Returns '' while the member isn't (yet) in the store, so route
 * data (breadcrumbs) can't crash on it.
 *
 * Standalone props-selector: `createFeature`'s `extraSelectors` only accepts
 * single-argument selectors or selector factories.
 */
export const selectName = createSelector(
  feature.selectEntities,
  (entities, byId: { id: number }): string => entities[byId.id]?.displayName ?? ''
);
